import React from 'react';
import { Link } from 'react-router-dom';
import BlogArticleLayout, { blogStyles as s } from './BlogArticleLayout';

function BlogArticleRGPDPilier() {
  return (
    <BlogArticleLayout
      tag="RGPD"
      title="RGPD et cybersécurité : ce que toute entreprise doit savoir"
      date="29 octobre 2026"
      ctaTitle="Faites le point sur votre conformité RGPD"
      ctaText="Le diagnostic couvre vos obligations RGPD en plus de la cybersécurité, avec un plan d'action unique plutôt que deux démarches séparées."
    >
      <p style={s.intro}>
        Le RGPD ne se limite pas à la sécurité de vos données, même si c'est souvent la porte d'entrée du
        sujet. C'est un ensemble d'obligations organisationnelles et documentaires qui concerne, de fait, la
        quasi-totalité des entreprises dès qu'elles traitent des données personnelles — salariés, clients ou
        prospects.
      </p>

      <h2 style={s.h2}>Tenir un registre des traitements</h2>
      <p>
        Le registre des traitements liste, pour chaque activité impliquant des données personnelles, sa
        finalité, les données concernées, les destinataires, la durée de conservation et les mesures de
        sécurité associées. C'est le document de référence qui structure toute votre démarche de conformité.
      </p>

      <h2 style={s.h2}>Informer les personnes concernées</h2>
      <p>
        Vos clients, prospects et salariés doivent être informés de la façon dont leurs données sont
        utilisées : politique de confidentialité claire, mentions d'information sur vos formulaires de
        collecte, information des salariés sur les traitements RH.
      </p>

      <h2 style={s.h2}>Respecter les droits des personnes</h2>
      <p>
        Toute personne peut demander l'accès à ses données, leur rectification, leur effacement, ou s'opposer
        à certains traitements. Votre entreprise doit être en mesure de répondre à ces demandes dans un délai
        encadré, ce qui suppose de savoir où se trouvent les données concernées — d'où l'importance du
        registre des traitements.
      </p>

      <h2 style={s.h2}>Encadrer la sous-traitance</h2>
      <p>
        Dès qu'un prestataire traite des données personnelles pour votre compte (hébergeur, logiciel de
        paie, outil marketing), un contrat de sous-traitance (souvent appelé DPA) doit encadrer ce traitement
        et les garanties de sécurité associées.
      </p>

      <h2 style={s.h2}>Définir des durées de conservation</h2>
      <p>
        Les données ne peuvent pas être conservées indéfiniment : chaque catégorie de données doit avoir une
        durée de conservation définie et justifiée, au terme de laquelle elles doivent être supprimées ou
        archivées selon des règles spécifiques.
      </p>

      <h2 style={s.h2}>Faut-il désigner un DPO ?</h2>
      <p>
        La désignation d'un délégué à la protection des données (DPO) est obligatoire dans certains cas
        (organismes publics, traitements à grande échelle de données sensibles ou de suivi systématique), et
        recommandée dans de nombreux autres cas même sans obligation stricte, pour centraliser le pilotage de
        la conformité.
      </p>

      <h2 style={s.h2}>Et la sécurité dans tout ça ?</h2>
      <p>
        La sécurité du traitement reste une composante centrale du RGPD, mais elle est distincte de ces
        obligations organisationnelles et documentaires. Nous la détaillons dans notre article
        {' '}<Link to="/blog/securite-des-donnees-rgpd" style={s.link}>La sécurité des données selon le RGPD</Link>.
      </p>

      <p style={s.disclaimer}>
        Cet article a une vocation informative et ne remplace pas une analyse juridique personnalisée par un
        professionnel du droit ou votre DPO.
      </p>
    </BlogArticleLayout>
  );
}

export default BlogArticleRGPDPilier;
